import Repository from "./Repository";

const ADD_RESOURCE = "add";
const GET_RESOURCE = "get";
const SCAN_DNS = "scanDNSRecord";
const CHECK_DATA = "checkData";
const GET_DB_DATA = "getDBData";
const GET_STORAGE_DATA = "getStorageData";

export default {
  addResource(payload) {
    return Repository.post(transformRoute(ADD_RESOURCE), payload);
  },
  getResource(payload) {
    return Repository.post(transformRoute(GET_RESOURCE), payload);
  },
  scanDNS(payload) {
    return Repository.post(transformRoute(SCAN_DNS), payload);
  },
  checkData(payload) {
    return Repository.post(transformRoute(CHECK_DATA), payload);
  },
  getDBData(payload) {
    return Repository.post(transformRoute(GET_DB_DATA), payload);
  },
  getStorageData(payload) {
    return Repository.post(transformRoute(GET_STORAGE_DATA), payload);
  },
};

const transformRoute = (route) => {
  return `/rsu/${route}`;
};
